import { Button } from "@shopify/polaris";
import { ClipboardMinor, TickMinor } from "@shopify/polaris-icons";
import React, { useCallback, useState, useEffect } from "react";

function CopyButton({ values, handleChange, item }) {
  const [copied, setCopied] = useState(false);
  const isDisabled = values?.[item]?.disable;

  const copyToClipboard = useCallback(
    async (value, field) => {
      if (!value) return;
      try {
        await navigator.clipboard.writeText(value);
      } catch {
        // Fallback for older browsers / non-secure contexts
        const el = document.createElement("textarea");
        el.value = value;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      setCopied(true);
      if (!isDisabled) {
        handleChange(field);
      }
    },
    [handleChange, isDisabled]
  );

  useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setCopied(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [copied]);
  return (
    <Button
      primary
      icon={copied ? TickMinor : ClipboardMinor}
      disabled={isDisabled}
      onClick={() => copyToClipboard(values?.[item]?.value, item)}
    >
      {/* {copied ? "Copied!" : "Copy"} */}
    </Button>
  );
}

export default CopyButton;
